export const TIME_TO_TRIGGER_TRACKING_ON_HOVER = 2000;
export const trackMenuUserAction = ({ action, label }) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'userAction',
        category: 'Navigation',
        action,
        label,
    });
};
export const trackMenuClickUserAction = ({ event, panelTitle, columnTitle, linkName, elementType, }) => {
    event.stopPropagation();
    trackMenuUserAction({
        action: `${panelTitle} Click`,
        label: `${columnTitle}_${linkName}_${elementType}`,
    });
};
export const trackMenuHoverUserAction = ({ topMenuLabel }) => {
    trackMenuUserAction({
        action: `${topMenuLabel} Impression`,
        label: '',
    });
};
//# sourceMappingURL=MenuUserAction.js.map